
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcCalendar as ObcCalendarElement} from '@oicl/openbridge-webcomponents/dist/components/calendar/calendar.js';
 import {CalendarEvent} from '@oicl/openbridge-webcomponents/dist/components/calendar/calendar-utils.js';
 export type {CalendarEvent} from '@oicl/openbridge-webcomponents/dist/components/calendar/calendar-utils.js';
 

 
 export const ObcCalendar = createComponent({
   react: React,
   tagName: 'obc-calendar',
   elementClass: ObcCalendarElement,
   events: {
     
     onMonthChange: 'month-change' as EventName<CustomEvent<{date: Date}>>,
     onDateSelect: 'date-select' as EventName<CustomEvent<{date: Date, events: CalendarEvent[]}>>,
     onTodayClick: 'today-click' as EventName<CustomEvent<void>>,
     onNewEventClick: 'new-event-click' as EventName<CustomEvent<void>>,
     onCalendarClick: 'calendar-click' as EventName<CustomEvent<void>>,
   }
  });
 
 